import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col, Button } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../actions/useaxios";
import config from "../../actions/config";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import Exportcsv from "../loginpages/Managementpages/Exportcsv";
import { DecryptData, EncryptData, isEmpty } from "../../actions/common";
import { toast } from "react-toastify";
function AdminList() {
  const [selectedOption, setSelectedOption] = useState(null);
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();

  const [seller, setseller] = useState();
  const [exportdata, setExportdata] = useState([]);
  const [Search, SetSearch] = useState("");
  const [disabled, SetDisabled] = useState(false);


  useEffect(() => {
    GetAdmin();
  }, [Search]);

  const GetAdmin = async () => {
    var resp = await axiosFile.getadmin({ Search: Search });
    console.log("dasdasdsadsa", resp);
    if (resp?.data?.length > 0) {
      var ddd =
        resp.length > 0
          ? (resp || [])?.map(({ _id, _v, ...rest }) => {
            return rest;
          })
          : [];
      setExportdata(ddd);
    }

    setseller([...(resp?.data ?? [])]);
    console.log('seeeeeeeeettttt', seller)
  };

  console.log('seeeeeeeeetttttoutttttttttt', seller)

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const driveroptions = [
    { value: "idle", label: "Idle" },
    { value: "intransit", label: "In Transit" },
    { value: "offline", label: "Offline" },
  ];

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const columns = [
    {
      dataField: "username",
      text: "Name",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p>{row?.username}</p>
        </>
      ),
    },
    {
      dataField: "EmailId",
      text: "Email-Id",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p>{row?.EmailId}</p>
        </>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, val) => (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <Link
                class="dropdown-item table_viewborbot"
                to={`/adminview/?Id=${String(
                  EncryptData(val?._id)
                )}`}
                state={{ data: val }}
              >
                View
              </Link>
            </li>
            <li onClick={() => StatusUpdate(val?._id)}>
              {console.log('valval', val)}
              <Link
                class="dropdown-item table_viewborbot">
                {val?.delete ? "Show" : "Hide"}
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  const StatusUpdate = async (id) => {
    if (!disabled) {
      SetDisabled(true);
      let toastid = toast.loading("Updating");
      let Resp = await axiosFile.AdminAction({ Type: 'delete', _id: id });
      if (Resp?.status) {
        toast.update(toastid, { render: Resp?.msg, type: Resp?.success, isLoading: false, autoClose: 1000 });
        GetAdmin();
      }
      else {
        toast.update(toastid, { render: Resp?.msg, type: Resp?.success, isLoading: false, autoClose: 1000 });
      }
      SetDisabled(false);
    }
  }

  // var header=csvData.map((item)=>
  //     [JSON.stringify(item)]
  //     )

  // const csvReport = {
  //     data: csvData,
  //     filename: fileName
  //   };

  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">Admin</p>
            </div>
            <div className="rightside">
              <button
                type="button"
                className="blue_btn add_deliveryprsn dp_btn_hover"
                onClick={() => navigate("/addadmin")}
              >
                Add Admin
              </button>

              {/* {exportdata && (
                              <Exportcsv
                                csvData={exportdata}
                                fileName={"users"}
                              />
                            )} */}

              {/* <CSVLink className="downloadbtn" filename="my-file.csv" data={csvData}>
        Export to CSV
      </CSVLink> */}
            </div>
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row">
              <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12">
                <div className="whole_searchbar white_bg">
                  <img
                    className="search_glass"
                    src={require("../../assests/images/Search.png")}
                    alt="calender"
                  />
                  <input placeholder="Search Admin Name/Email" onChange={(e) => SetSearch(e.target.value)} value={Search} />
                </div>
              </div>

              {/* <div className="col-xxl-8 col-xl-8 col-lg-9 col-md-9 col-sm-12 col-12">
                              <div className="rightside">
                                <div className="rightside_select">
                                  <Select
                                    options={options}
                                    defaultValue={selectedOption}
                                    styles={stylesgraybg}
                                    onChange={setSelectedOption}
                                    className="border_blue_select"
                                    classNamePrefix="react-select"
                                    placeholder="Type"
                                  />
                                </div>

                                <div className="rightside_select">
                                  <Select
                                    options={driveroptions}
                                    defaultValue={selectedOption}
                                    styles={stylesgraybg}
                                    onChange={setSelectedOption}
                                    className="border_blue_select"
                                    classNamePrefix="react-select"
                                    placeholder="Status"
                                  />
                                </div>
                              </div>
                            </div> */}
              {seller && (
                <div className="ffd_table mar_bot vendor_table_align">
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    columns={columns}
                    data={seller}
                    pagination={pagination}
                    noDataIndication="No Admin found"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminList;
